import { useContext }                   from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthContext }                  from "../auth/AuthContext";
import { HospitalAdministracion }       from "../components/HospitalAdministracion";
import { HospitalCategorias }           from "../components/HospitalCategorias";
import { HospitalDetalle }              from "../components/HospitalDetalle";
import { HospitalOperacion }              from "../components/HospitalOperacion";
import { HospitalEstadistica }          from "../components/HospitalEstadistica/HospitalEstadistica";
import { MenuPage }                     from "../components/MenuPage/MenuPage";
import { WithoutMenu }                  from "../components/WithoutMenu";
import { ProtectedAnyRoute }            from "./ProtectedAnyRoute";
import { ProtectedLoginPage }           from "./ProtectedLoginPage";
import { ProtectedRoute }               from "./ProtectedRoute";
import { HospitalGestion } from "../components/HospitalGestion/HospitalGestion";
import { HospitalGrafica } from "../components/HospitalEstadistica/HospitalGrafica";

export const AppRouter = () => {
  const {logged} = useContext(AuthContext)

  return (
    <BrowserRouter>
      <Routes>
        {/* Not logged */}
        <Route path="/login" element={<ProtectedLoginPage/>}/>
        <Route path="/" element={<ProtectedAnyRoute/>}/>

        {/* Logged */}
        {/* This conditional is to fix a bad effect UI */}
        {logged && (
        <Route element={<MenuPage/>}>
          <Route path="/coflpa" element={<ProtectedRoute path="/coflpa"><HospitalDetalle/></ProtectedRoute>}/>
          <Route path="/coflpa/detalle" element={<ProtectedRoute path="/coflpa/detalle"><HospitalDetalle/></ProtectedRoute>}/>
          <Route path="/coflpa/operacion" element={<ProtectedRoute path="/coflpa/operacion"><HospitalOperacion/></ProtectedRoute>}/>
          <Route path="/coflpa/gestion" element={<ProtectedRoute path="/coflpa/gestion"><HospitalGestion/></ProtectedRoute>}/>
          <Route path="/coflpa/estadistica" element={<ProtectedRoute path="/coflpa/estadistica"><HospitalEstadistica/></ProtectedRoute>}/>
          <Route path="/coflpa/grafica" element={<ProtectedRoute path="/coflpa/grafica"><HospitalGrafica/></ProtectedRoute>}/>
          <Route path="/coflpa/administracion" element={<ProtectedRoute path="/coflpa/administracion"><HospitalAdministracion/></ProtectedRoute>}/>
          <Route path="/coflpa/categorias" element={<ProtectedRoute path="/coflpa/categorias"><HospitalCategorias/></ProtectedRoute>}/>
          <Route path="/without-menu" element={<ProtectedRoute path="/without-menu"><WithoutMenu/></ProtectedRoute>}/>
        </Route>
        )}

        {/* Any route */}
        <Route path="*" element={<ProtectedAnyRoute/>}/>
      </Routes>
    </BrowserRouter>
  );
}